require("./wdh-legacy/intro-banner/js/corporate-template/component-intro-banner.js");